import React from "react";
import { Link } from "react-scroll";
import { siteLogo } from "../../global";
import { HashLink } from "react-router-hash-link";

const Footer = ({ menu, isBg }) => {
  return (
    <>
      <footer
        className={`footer overflow-hidden ${isBg === "yes" ? "bg-one" : ""}`}
      >
        <div className="container">
          <div className="footer__top m-50px-t m-50px-b">
            <div className="row">
              <div className="col-lg-3 d-flex justify-content-center align-items-center mb-3 mb-lg-0 justify-content-lg-start">
                <a href="/">
                  {/* <!-- <h1 className="m-0">WONTED</h1> --> */}
                  <img src={siteLogo.logo} alt={siteLogo.alt} />
                </a>
              </div>
              <div className="col-lg-6 d-flex justify-content-center align-items-center mb-3 mb-lg-0">
                <ul className="footer__menu">
                  {menu?.map((data, i) => (
                    <li key={i}>
                      {data.isPageLink ? (
                        <HashLink to={data.link} className="benefits nav-link">
                          {data.title}
                        </HashLink>
                      ) : (
                        <Link
                          activeClass="active"
                          className="benefits"
                          to={data.link}
                          spy={true}
                          smooth={true}
                          duration={500}
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          offset={-60}
                        >
                          {data.title}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-lg-3 d-flex justify-content-center align-items-center mb-3 mb-lg-0 justify-content-lg-end">
                <ul className="social-icon">
                  <li>
                    <a href="https://instagram.com/jutefoster" target="_blank" rel="noopener noreferrer" >
                      <img
                        className="img-fluid"
                        src="assets/icons/Instagram_Glyph_White.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://discord.gg/JUcBUxuYUd" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/Discord-Symbol-White.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="https://facebook.com/jutefoster" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/facebook.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </footer>
    </>
    // <!-- ========== Footer section End ========== -->
  );
};

export default Footer;
